import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, createBlock as _createBlock, normalizeStyle as _normalizeStyle, vModelSelect as _vModelSelect, withDirectives as _withDirectives, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1875b12c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "mt-8 mx-12 md:mx-28 text-white" }
const _hoisted_2 = { class: "flex space-x-2 text-sm" }
const _hoisted_3 = /*#__PURE__*/_createTextVNode("All Genre ")
const _hoisted_4 = { class: "grid grid-cols-2 md:grid-cols-4 mt-8 gap-4" }
const _hoisted_5 = {
  key: 0,
  class: "flex flex-col xl:flex-row text-center xl:text-left min-h-full justify-between items-center px-2 py-4 md:px-3 border-2 border-gray-500 hover:border-red-hover hover:bg-red-hover cursor-pointer rounded-lg transition-all duration-200"
}
const _hoisted_6 = { class: "text-md font-bold truncate" }
const _hoisted_7 = { class: "text-xs flex" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "ml-1" }, "Games", -1))
const _hoisted_9 = { class: "py-8 text-white mx-12 md:mx-28" }
const _hoisted_10 = { class: "flex space-x-8 uppercase text-sm" }
const _hoisted_11 = { class: "border-2 p-2 bg-red-hover border-red-hover" }
const _hoisted_12 = {
  key: 0,
  class: "grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-5 gap-6 py-6"
}
const _hoisted_13 = {
  key: 0,
  class: "flex flex-col space-y-4 card-cover"
}
const _hoisted_14 = { class: "group relative hover:-translate-y-2 translation-all duration-200" }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "rounded-2xl absolute opacity-0 top-0 left-0 h-full justify-center items-center flex w-full bg-red-hover bg-opacity-30 group-hover:opacity-100" }, [
  /*#__PURE__*/_createElementVNode("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    "xmlns:xlink": "http://www.w3.org/1999/xlink",
    "aria-hidden": "true",
    role: "img",
    class: "iconify iconify--material-symbols fill-white",
    width: "60",
    height: "60",
    preserveAspectRatio: "xMidYMid meet",
    viewBox: "0 0 24 24"
  }, [
    /*#__PURE__*/_createElementVNode("path", {
      fill: "currentColor",
      d: "m9.5 16.5l7-4.5l-7-4.5ZM12 22q-2.075 0-3.9-.788q-1.825-.787-3.175-2.137q-1.35-1.35-2.137-3.175Q2 14.075 2 12t.788-3.9q.787-1.825 2.137-3.175q1.35-1.35 3.175-2.138Q9.925 2 12 2t3.9.787q1.825.788 3.175 2.138q1.35 1.35 2.137 3.175Q22 9.925 22 12t-.788 3.9q-.787 1.825-2.137 3.175q-1.35 1.35-3.175 2.137Q14.075 22 12 22Zm0-2q3.35 0 5.675-2.325Q20 15.35 20 12q0-3.35-2.325-5.675Q15.35 4 12 4Q8.65 4 6.325 6.325Q4 8.65 4 12q0 3.35 2.325 5.675Q8.65 20 12 20Zm0-8Z"
    })
  ])
], -1))
const _hoisted_16 = { class: "flex flex-col" }
const _hoisted_17 = {
  key: 0,
  class: "text-md md:text-xl truncate font-bold"
}
const _hoisted_18 = {
  key: 1,
  class: "text-gray-text truncate h-5 display-block"
}
const _hoisted_19 = ["innerHTML"]
const _hoisted_20 = {
  key: 1,
  class: "flex flex-col space-y-4 card-cover"
}
const _hoisted_21 = { class: "group relative hover:-translate-y-2 translation-all duration-200" }
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "rounded-2xl absolute opacity-0 top-0 left-0 h-full justify-center items-center flex w-full bg-red-hover bg-opacity-30 group-hover:opacity-100" }, [
  /*#__PURE__*/_createElementVNode("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    "xmlns:xlink": "http://www.w3.org/1999/xlink",
    "aria-hidden": "true",
    role: "img",
    class: "iconify iconify--material-symbols fill-white",
    width: "60",
    height: "60",
    preserveAspectRatio: "xMidYMid meet",
    viewBox: "0 0 24 24"
  }, [
    /*#__PURE__*/_createElementVNode("path", {
      fill: "currentColor",
      d: "m9.5 16.5l7-4.5l-7-4.5ZM12 22q-2.075 0-3.9-.788q-1.825-.787-3.175-2.137q-1.35-1.35-2.137-3.175Q2 14.075 2 12t.788-3.9q.787-1.825 2.137-3.175q1.35-1.35 3.175-2.138Q9.925 2 12 2t3.9.787q1.825.788 3.175 2.138q1.35 1.35 2.137 3.175Q22 9.925 22 12t-.788 3.9q-.787 1.825-2.137 3.175q-1.35 1.35-3.175 2.137Q14.075 22 12 22Zm0-2q3.35 0 5.675-2.325Q20 15.35 20 12q0-3.35-2.325-5.675Q15.35 4 12 4Q8.65 4 6.325 6.325Q4 8.65 4 12q0 3.35 2.325 5.675Q8.65 20 12 20Zm0-8Z"
    })
  ])
], -1))
const _hoisted_23 = { class: "flex flex-col" }
const _hoisted_24 = {
  key: 0,
  class: "text-md md:text-xl truncate font-bold"
}
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-gray-text truncate h-5 display-block" }, " - ", -1))
const _hoisted_26 = {
  key: 1,
  class: "text-lg my-2"
}
const _hoisted_27 = {
  key: 2,
  class: "navigation_div"
}
const _hoisted_28 = { class: "navigation-num" }
const _hoisted_29 = /*#__PURE__*/_createTextVNode(" Show ")
const _hoisted_30 = /*#__PURE__*/_createStaticVNode("<option value=\"10\" data-v-1875b12c>10</option><option value=\"20\" data-v-1875b12c>20</option><option value=\"30\" data-v-1875b12c>30</option><option value=\"40\" data-v-1875b12c>40</option><option value=\"50\" data-v-1875b12c>50</option>", 5)
const _hoisted_35 = [
  _hoisted_30
]
const _hoisted_36 = /*#__PURE__*/_createTextVNode(" Records ")
const _hoisted_37 = { class: "navigation-menu" }
const _hoisted_38 = {
  key: 2,
  class: "option-disabled"
}
const _hoisted_39 = { class: "navigation-text" }
const _hoisted_40 = {
  key: 4,
  class: "option-disabled"
}
const _hoisted_41 = {
  key: 6,
  class: "option-disabled"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("main", null, [
    _createElementVNode("section", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_component_router_link, {
          to: { name: 'viewGamesGenre' },
          class: "border-2 p-2 border-red-hover bg-red-hover justify-items-end"
        }, {
          default: _withCtx(() => [
            _hoisted_3
          ]),
          _: 1
        })
      ]),
      _createElementVNode("div", _hoisted_4, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.sortedGenre, (genre, index) => {
          return (_openBlock(), _createBlock(_component_router_link, {
            to: { name: 'viewGamesGenre', params: { category: genre.value } },
            key: index
          }, {
            default: _withCtx(() => [
              (genre.count > 0)
                ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                    _createElementVNode("span", _hoisted_6, _toDisplayString(genre.value), 1),
                    _createElementVNode("span", _hoisted_7, [
                      _createTextVNode(_toDisplayString(genre.count), 1),
                      _hoisted_8
                    ])
                  ]))
                : _createCommentVNode("", true)
            ]),
            _: 2
          }, 1032, ["to"]))
        }), 128))
      ])
    ]),
    _createElementVNode("section", _hoisted_9, [
      _createElementVNode("div", _hoisted_10, [
        _createElementVNode("button", _hoisted_11, "All " + _toDisplayString(_ctx.Genre) + " Games", 1)
      ]),
      (_ctx.displayGames)
        ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.displayGames, (game, index) => {
              return (_openBlock(), _createElementBlock("div", { key: index }, [
                (game.details)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                      (game.game.gameId)
                        ? (_openBlock(), _createBlock(_component_router_link, {
                            key: 0,
                            to: { name: 'viewGamesProfile', params: { gameId: game.game.gameId } }
                          }, {
                            default: _withCtx(() => [
                              _createElementVNode("div", _hoisted_14, [
                                (game.details.gallery.headerImage)
                                  ? (_openBlock(), _createElementBlock("div", {
                                      key: 0,
                                      class: "card-img-top rounded-2xl w-full",
                                      style: _normalizeStyle('background: url(' + _ctx.assetURL + 'blob/games/' + game.game.gameId + '/gallery/' + game.details.gallery.headerImage + ') #000; background-repeat: no-repeat; background-size: cover; background-position: center')
                                    }, null, 4))
                                  : (_openBlock(), _createElementBlock("div", {
                                      key: 1,
                                      class: "card-img-top rounded-2xl",
                                      style: _normalizeStyle('background: url(' + require(`@/assets/images/default-cover-small.png`) + '); background-repeat: no-repeat; background-size: cover;')
                                    }, null, 4)),
                                _hoisted_15
                              ])
                            ]),
                            _: 2
                          }, 1032, ["to"]))
                        : _createCommentVNode("", true),
                      _createElementVNode("div", _hoisted_16, [
                        (game.game.title)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_17, _toDisplayString(game.game.title), 1))
                          : _createCommentVNode("", true),
                        (game.details.about.about == null)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_18))
                          : (_openBlock(), _createElementBlock("small", {
                              key: 2,
                              class: "text-gray-text truncate",
                              innerHTML: game.details.about.about.replace(/<\/?[^>]+>/ig, '').substring(0, 100)
                            }, null, 8, _hoisted_19))
                      ])
                    ]))
                  : (_openBlock(), _createElementBlock("div", _hoisted_20, [
                      (game.game.gameId)
                        ? (_openBlock(), _createBlock(_component_router_link, {
                            key: 0,
                            to: { name: 'viewGamesProfile', params: { gameId: game.game.gameId } }
                          }, {
                            default: _withCtx(() => [
                              _createElementVNode("div", _hoisted_21, [
                                _createElementVNode("div", {
                                  class: "card-img-top rounded-2xl",
                                  style: _normalizeStyle('background: url(' + require(`@/assets/images/default-cover-small.png`) + '); background-repeat: no-repeat; background-size: cover;')
                                }, null, 4),
                                _hoisted_22
                              ])
                            ]),
                            _: 2
                          }, 1032, ["to"]))
                        : _createCommentVNode("", true),
                      _createElementVNode("div", _hoisted_23, [
                        (game.game.title)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_24, _toDisplayString(game.game.title), 1))
                          : _createCommentVNode("", true),
                        _hoisted_25
                      ])
                    ]))
              ]))
            }), 128))
          ]))
        : _createCommentVNode("", true),
      (_ctx.displayGames.length <= 0)
        ? (_openBlock(), _createElementBlock("div", _hoisted_26, " There are no games in " + _toDisplayString(_ctx.Genre) + ". ", 1))
        : _createCommentVNode("", true),
      (_ctx.Genre?_ctx.genreGames.length>10:_ctx.games.length>10)
        ? (_openBlock(), _createElementBlock("div", _hoisted_27, [
            _createElementVNode("div", _hoisted_28, [
              _hoisted_29,
              _withDirectives(_createElementVNode("select", {
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.pages) = $event)),
                class: "",
                onChange: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.changeRows && _ctx.changeRows(...args)))
              }, _hoisted_35, 544), [
                [_vModelSelect, _ctx.pages]
              ]),
              _hoisted_36
            ]),
            _createElementVNode("div", _hoisted_37, [
              (_ctx.enableFirstPage)
                ? (_openBlock(), _createElementBlock("div", {
                    key: 0,
                    onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.naviFirst && _ctx.naviFirst(...args))),
                    class: "option"
                  }, "First"))
                : _createCommentVNode("", true),
              (_ctx.enablePreviousPage)
                ? (_openBlock(), _createElementBlock("div", {
                    key: 1,
                    onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.naviPrevious && _ctx.naviPrevious(...args))),
                    class: "option"
                  }, " Previous "))
                : (_openBlock(), _createElementBlock("div", _hoisted_38, "Previous")),
              _createElementVNode("div", _hoisted_39, " Page " + _toDisplayString(_ctx.currentPage) + " of " + _toDisplayString(_ctx.totalPages), 1),
              (_ctx.enableNextPage)
                ? (_openBlock(), _createElementBlock("div", {
                    key: 3,
                    onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.naviNext && _ctx.naviNext(...args))),
                    class: "option"
                  }, "Next"))
                : (_openBlock(), _createElementBlock("div", _hoisted_40, "Next")),
              (_ctx.enableLastPage)
                ? (_openBlock(), _createElementBlock("div", {
                    key: 5,
                    onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.naviLast && _ctx.naviLast(...args))),
                    class: "option"
                  }, "Last"))
                : (_openBlock(), _createElementBlock("div", _hoisted_41, "Last"))
            ])
          ]))
        : _createCommentVNode("", true)
    ])
  ]))
}